namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_code, {

		Code_head: {
			background: {
				color: $mol_theme.card,
			},
		},

		Drag_overlap: {
			pointerEvents: 'none',
		},
		
		Widget_title_edit: {
			['fieldSizing' as any]: 'content',
			flex: {
				grow: 0,
			},
			margin: {
				right: 'auto',
			},
		},

		Bench: {
			Card: {
				paddingTop: '0',
			},
		},

		Textarea: {
			pointerEvents: 'none',
			flex: {
				grow: 0,
			},
			Edit: {
				pointerEvents: 'auto',
			},
			padding: {
				top: $mol_gap.block,
				left: $mol_gap.block,
			},
			margin: $mol_gap.block,
			marginTop: '0',
			// {
			// 	top 0
			// 	$mol_gap.block,
			// }

			View: {
				Copy: {
					position: 'absolute',
					left: '-1rem',
					fontSize: '1rem',
				},
				Row: {
					Numb: {
						// position: 'sticky',
						// left: 0,
						// pointerEvents: 'auto',
					},
					[':has(:only-child)' as ':empty']: {
						height: '1.5em',
					},
				},
			},
			
			lineHeight: '1.5',
		},
		
	} )
	
}
